import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton } from "@material-ui/core";
import Launch from "@material-ui/icons/Launch";
import Add from "@material-ui/icons/Add";

export default class DbtResearchProjectTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoaded: false,
    };
  }

  handleDelete(rowsDeleted) {
    console.log(rowsDeleted);
  }

  onActionClick(el) {
    this.props.actionClick(el);
  }

  onDeleteClick(el) {
    this.props.deleteClick(el);
  }

  render() {
    const columns = [
      {
        name: "#",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Equipment / Asset",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Sanctioned Cost",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Actual Cost",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Quantity",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Date of Purchase",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Photo",
        options: {
          filter: false,
          sort: false,
          download: false,
          customBodyRender: (rr) => {
            if (Array.isArray(rr) && rr.length > 0) {
              return (
                <img
                  src={rr[0].url}
                  style={{ width: 80 }}
                  alt="equipment"
                />
              );
            }
            return null;
          },
        },
      },
      {
        name: "Time",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "Action",
        options: {
          filter: false,
          sort: false,
          download: false,
        },
      },
    ];

    const options = {
      filterType: "checkbox",
      selectableRows: false,
      responsive: "scroll",
      onRowsDelete: (rowsDeleted) => {
        this.handleDelete(rowsDeleted);
      },
      customToolbar: () => {
        return (
          <IconButton onClick={this.props.onAddClick}>
            <Add />
          </IconButton>
        );
      },
    };

    let data = [];
    let table_data = this.props.table_data;
    if (table_data.length > 0) {
      data = table_data.map((el, index) => [
        el.id,
        el.equipment_name,
        el.sanctioned_cost,
        el.actual_cost,
        el.quantity_procured,
        el.date_of_purchase,
        el.upload_info,
        el.time_stamp,
        <Launch onClick={this.onActionClick.bind(this, el)} />,
      ]);
    } else {
      data = [];
    }

    return (
      <div>
        <MUIDataTable
          title={`DBT Research Project`}
          data={data}
          columns={columns}
          options={options}
        />
      </div>
    );
  }
}
